/** Local datetime stamp for inventory CSV downloads: yyyy-MM-ddTHH:mm */
export function formatInventoryCsvTimestamp(date = new Date()): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
        `T${pad(date.getHours())}:${pad(date.getMinutes())}`
    );
}

export function formatInventoryExportFilename(date = new Date()): string {
    return `partbay-inventory-export-${formatInventoryCsvTimestamp(date)}.csv`;
}

export function formatInventoryImportIssuesFilename(date = new Date()): string {
    return `partbay-import-issues-${formatInventoryCsvTimestamp(date)}.csv`;
}
